module.exports = __webpack_public_path__ + "static/media/image_banner_b2b.f42b2652.png";